import React from 'react'
import PropTypes from 'prop-types'
import styles from './statusBoard.style'

const StatusBoard = props => {
  return (
    <div style={styles.board}>
      <h3 style={styles.label}>{props.title}</h3>
      <div style={styles.result}>{props.data}</div>
      <div style={styles.comment}>{props.comment}</div>
      <div style={styles.selections}>{props.footer}</div>
    </div>
  )
}

StatusBoard.propTypes = {
  data: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  footer: PropTypes.string.isRequired,
}

export default StatusBoard
